import React, {Component} from 'react';
import {Trans} from '@lingui/macro';

import ReportIcon from '../Icons/ReportIcon';
import ChevronDownIcon from '../Icons/ChevronDownIcon';
import LoadingSpinner from '../LoadingSpinner';
import IndividualReport from '../IndividualReport';

import useFetch from '../../hooks/useFetch';
import {getReportUrl} from '../../services/utilities';

import cl from 'classnames';
import s from './ReportsList.css';

function ReportsList({campaignId, userId, jasperReports, noReportText, canDownloadReport}) {
  const {
    fetchStatus: configFetchStatus,
    data: config,
    error: configError,
  } = useFetch(`report/${campaignId}/config`);

  if ([configFetchStatus].some(status => status === 'PENDING' || status === 'IDLE')) {
    return <LoadingSpinner delay={500} />;
  }

  const canAssessedDownloadConfig = config?.report?.individualConf?.individual?.canAssessedDownload;

  //IF JASPER REPORT IS AVAILABLE SHOW THAT
  //OTHERWISE SHOW THE ONLINE ONE
  if (jasperReports.size > 0) {
    return (
      <OldReportsList
        canDownloadReport={canDownloadReport && canAssessedDownloadConfig}
        jasperReports={jasperReports}
        campaignId={campaignId}
        config={config}
      />
    );
  }

  return <NewReportsList config={config} campaignId={campaignId} userId={userId} />;
}

function OldReportsList({jasperReports, campaignId, canDownloadReport}) {
  const downloadableReports = jasperReports.filter(
    item => item.getIn(['visibleToAssessorsOnly']) == false
  );
  const doDownloadReport = downloadableReports.size > 0;

  if (!canDownloadReport || !doDownloadReport) {
    return <NoReportYet campaignId={campaignId} />;
  }

  return (
    <div className={s.ReportsPage}>
      <div className={s.Container}>
        <a
          className={cl(s.Link)}
          href={getReportUrl(jasperReports.getIn([0, 'id']), campaignId)}
          target={'_blank'}
        >
          &nbsp;
        </a>
        <ReportIcon className={cl(s.ReportIcon, s.Animation)} />
        <ChevronDownIcon className={cl(s.ArrowIcon, s.Animation)} />
        <h2 className={s.Text}>
          <Trans id="report.ready_for_download">Il report è pronto per il download</Trans>
        </h2>
        <Trans render={({translation}) => <p>{translation}</p>} id="report.download_your_report">
          Scarica il tuo report personale. Troverai tutte le informazioni relative alle prove che
          hai affrontato in questa sessione.
        </Trans>
      </div>
    </div>
  );
}

function NewReportsList({campaignId, userId, config}) {
  const {
    fetchStatus: reportFetchStatus,
    data: report,
    error: reportError,
  } = useFetch(`report/${campaignId}/individual/personal/${userId}`, {redirectOnUnauth: false});

  if ([reportFetchStatus].some(status => status === 'PENDING' || status === 'IDLE')) {
    return <LoadingSpinner delay={500} />;
  }

  const result = report?.result;

  if (
    reportError ||
    !result ||
    !config?.report?.individualConf?.individual?.canAssessedDownload ||
    !result?.rep?.areas ||
    result.rep.areas.length === 0
  ) {
    return <NoReportYet campaignId={campaignId} />;
  }

  return (
    <div className={s.ReportContainer}>
      <IndividualReport report={result.rep} userId={userId} campaignId={campaignId} />
    </div>
  );
}

class NoReportYet extends Component {
  mainRef = React.createRef();

  componentDidMount() {
    this.mainRef.current.focus();
  }
  render() {
    const {campaignId} = this.props;

    return (
      <div className={s.ReportsPage} aria-live="assertive">
        <div className={s.Container}>
          <ReportIcon className={cl(s.ReportIcon)} customColor={'#C3C3C3'} />
          <ChevronDownIcon className={cl(s.ArrowIcon)} />
          <h2 tabIndex="-1" ref={this.mainRef} className={s.Text}>
            <Trans id="report.no_report_available">Nessun report disponibile</Trans>
          </h2>
          <p>
            <Trans id="report.page_not_active">La pagina di report non è ancora attiva.</Trans>
            <br />
            <Trans id="report.will_notify_when_page_available">
              Ti avviseremo quando sarà disponibile.
            </Trans>
          </p>
        </div>
      </div>
    );
  }
}

export {ReportsList};
